import { Button } from '@talentmesh/ui/components/button';
import { DialogTitle } from '@talentmesh/ui/components/dialog';
import { XIcon } from 'lucide-react';

interface PopupDialogTitleProps {
    title: string;
    close: () => void;
}

function PopupDialogTitle({ title, close }: PopupDialogTitleProps) {
    return (
        <DialogTitle className="flex flex-row items-center justify-between gap-4">
            <span>{title}</span>
            <Button variant="ghost" size="icon-sm" onClick={close} data-cy="closeDialogButton" aria-label="Close">
                <XIcon />
            </Button>
        </DialogTitle>
    );
}

export default PopupDialogTitle;
